import { Icon, IconName } from 'components/Icon/Icon';
import React from 'react';

export type IconButtonProps = {
  icon: string;
  tooltip: string;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

export const IconButton: React.FC<IconButtonProps> = ({
  icon,
  tooltip,
  ...props
}) => {
  return (
    <button
      className="bg-grey-100 hover:bg-grey-300 inline-block rounded-full p-2"
      {...props}
    >
      <Icon
        name={icon as IconName}
        inline={true}
        tooltip={tooltip}
        color="#434345"
      />
    </button>
  );
};
